import { Inject, Injectable } from '@angular/core';

export class ServiceEndPoints {
  static AUTHENTICATION_URL = 'AUTHENTICATION_URL';
}

@Injectable({
  providedIn: 'root',
})
export class AuthEnvironmentService {
  public auth_services = '/no_auth_host';
  public service_host = '/no_service_host';
  public protocol = '';

  private env_vars: any = new Object();

  constructor(@Inject('environment') public envVariables: any) {
    if (envVariables.protocol) {
      this.protocol = envVariables.protocol;
    }

    if (envVariables.service_host != null) {
      this.service_host = envVariables.service_host;
    }
    if (envVariables.auth_services) {
      this.auth_services = envVariables.auth_services;
    }

    // register all vars
    this.registerVars();
  }

  public registerVars() {
    this.env_vars[ServiceEndPoints.AUTHENTICATION_URL] =
      this.protocol + this.service_host + this.auth_services + '/login?client_name=DirectFormClient';
  }

  public getEnvVar(arg: string): string {
    return this.env_vars[arg];
  }
}
